import type { FaireProductEntity } from "../../entity_types/product";

export const p_f2hp7egseh: FaireProductEntity = {
  token: "p_f2hp7egseh",
  type: "product",
  name: "Woon Sea Moss Seasoning",
  brandToken: "b_th428x9zzy",
  brandName: "Woon",
  imageUrl: "https://cdn.faire.com/fastly/e288d23b77b3f24edf8702b4ab8530f257844eeea9f7e87fa332446d0c451e8b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/78d7dbc322089d685b6c2c88ed52682a015544913aff02cdfde69c819e678164.jpeg",
    "https://cdn.faire.com/fastly/b14240499d65d6ee2942abad29d6af50edadc35f3abf6bbe641468c8afdb75d3.jpeg",
    "https://cdn.faire.com/fastly/3de8ba1e962310181caa23a875281079492931de5409cf01d294dedb88e1f054.jpeg",
    "https://cdn.faire.com/fastly/b762b7cbcebddb6c5a9f32ab806f73632ef3d41491e4e9ef7a2f74f6db24745d.jpeg",
    "https://cdn.faire.com/fastly/496d8b41660ec2fdaac9ee9992c7e0d8c72491a1702e9dd0b0a063aeeebe7f47.jpeg"
  ],
  priceDollars: 11.2,
  description: "A pantry must-have! We probably use this product the most. Dehydrated, roasted sea moss blended with sea salt adds an umami bomb to any dish. Note: Sea moss is not seaweed. It has more umami and smells like the ocean. Sprinkle on rice, avocado toast, eggs, popcorn, noodles... possibly anything.",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:56.381Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
